import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';

//import { AddressTypeService } from '../../config/shared/'

import { FormElementProfileAddress } from '../shared/model/profile/address/form-element-profile-address.model';
import { AddressTypeService } from 'src/app/admin/codes/shared/address-type.service';
import { AddressType } from 'src/app/admin/codes/shared/dto/address-type.model';

@Component({
  selector: 'wl-form-builder-profile-address-edit-element',
  templateUrl: 'form-builder-profile-address-edit-element.component.html',
    standalone: false
})
export class FormBuilderProfileAddressEditElementComponent {
  private _translationService: TranslationService;
  private _addressTypeService: AddressTypeService;

  public selectedAddressTypeId: number;
  public profileAddressSettings: FormElementProfileAddress;
  public addressTypes: Array<AddressType>;

  public constructor(translationService: TranslationService, addressTypeService: AddressTypeService) {
    this._translationService = translationService;
    this._addressTypeService = addressTypeService;
  }

  ngOnInit(): void {
    this.profileAddressSettings = new FormElementProfileAddress();
    this._addressTypeService.getDefaultBillingAndMailingAddressTypes().then((data: Array<AddressType>) => {
      this.addressTypes = data;
    });
  }

  onAddressTypeChange(): void {
    this.profileAddressSettings.AddressType = this.addressTypes.find((x) => x.AddressTypeID == this.profileAddressSettings.AddressTypeId);
  }
}
